import { render, staticRenderFns } from "./UpdatePassword1.vue?vue&type=template&id=05150a8f&"
import script from "./UpdatePassword1.vue?vue&type=script&lang=js&"
export * from "./UpdatePassword1.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports